import { render } from "./AddMediaModal.vue?vue&type=template&id=dc256718&scoped=true"
import script from "./AddMediaModal.vue?vue&type=script&lang=js"
export * from "./AddMediaModal.vue?vue&type=script&lang=js"

import "./AddMediaModal.vue?vue&type=style&index=0&id=dc256718&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc256718"]])

export default __exports__